import type { HelpFile } from '../../types/help'
import { OwnersPickerTestIds } from '../../../testids/OwnersPickerTestIds'

export const ownersPickerHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rule-requests',
  texts: {
    [OwnersPickerTestIds.ownersEditor]:
      'Wähle eine oder mehrere Parteien aus, die für diese Entität verantwortlich sind. Jede Owner-Zeile trägt einen Verantwortlichkeitscode (Geschäftlich, Technisch, …).',
    [OwnersPickerTestIds.btnAddOwner]:
      'Eine weitere Owner-Zeile hinzufügen.',
    [OwnersPickerTestIds.btnRemoveOwnerPrefix()]: null,
    [OwnersPickerTestIds.comboboxOwnerPartyPrefix()]: null,
    [OwnersPickerTestIds.ownerRowPrefix()]: null,
    [OwnersPickerTestIds.selectOwnerResponsibilityPrefix()]: null,
  },
}
